import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL;
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error("Missing Supabase environment variables");
}

export const supabase = createClient(supabaseUrl, supabaseAnonKey);

export type Database = {
  public: {
    Tables: {
      fraud_database: {
        Row: {
          id: string;
          account_number: string;
          account_type: "bank" | "ewallet" | "crypto";
          institution_name: string | null;
          risk_level: "safe" | "low" | "medium" | "high" | "critical";
          fraud_type: string | null;
          report_count: number;
          confidence_score: number;
          first_reported_at: string | null;
          last_reported_at: string | null;
          is_verified: boolean;
          created_at: string;
          updated_at: string;
        };
        Insert: Omit<
          Database["public"]["Tables"]["fraud_database"]["Row"],
          "id" | "created_at" | "updated_at"
        >;
        Update: Partial<
          Database["public"]["Tables"]["fraud_database"]["Insert"]
        >;
      };
      fraud_reports: {
        Row: {
          id: string;
          user_id: string;
          reported_account: string;
          account_type: "bank" | "ewallet" | "crypto";
          institution_name: string | null;
          fraud_type: string;
          description: string;
          incident_date: string | null;
          evidence_files: string[] | null;
          status: "pending" | "under_review" | "verified" | "rejected";
          severity_score: number | null;
          created_at: string;
          updated_at: string;
        };
        Insert: Omit<
          Database["public"]["Tables"]["fraud_reports"]["Row"],
          "id" | "created_at" | "updated_at"
        >;
        Update: Partial<
          Database["public"]["Tables"]["fraud_reports"]["Insert"]
        >;
      };
      user_profiles: {
        Row: {
          id: string;
          user_id: string;
          email: string;
          credibility_score: number;
          created_at: string;
          updated_at: string;
        };
        Insert: Omit<
          Database["public"]["Tables"]["user_profiles"]["Row"],
          "id" | "created_at" | "updated_at"
        >;
        Update: Partial<
          Database["public"]["Tables"]["user_profiles"]["Insert"]
        >;
      };
    };
  };
};
